import { render, staticRenderFns } from "./appleWallet.vue?vue&type=template&id=1f8d0606"
import script from "./appleWallet.vue?vue&type=script&lang=js"
export * from "./appleWallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports